// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"19ba7480","64":"048a3b2b","292":"0dbe3c97","453":"edd102e0","475":"5c8d65fc","575":"ad207912","582":"41690811","652":"4d90260b","806":"d0b7a239","823":"299ac23b"}[chunkId] + ".chunk.js";
};